import { Box, BoxProps, Text } from '@chakra-ui/react';
import { HighlightSearchTerm } from '~/components/HighlightSearchTerm';
import { convertPxToRems } from '~/utils-ts';

import { cellContainer } from './styles';

interface Props extends BoxProps {
  text: string;
}

export const TextInfo: React.FC<Props> = ({ text, ...props }) => {
  return (
    <Box {...cellContainer} {...props}>
      {text ? (
        <Text
          color="primary.400"
          fontSize="md"
          fontWeight="400"
          lineHeight={convertPxToRems(14)}
        >
          <HighlightSearchTerm>{text}</HighlightSearchTerm>
        </Text>
      ) : (
        <EmptyCell />
      )}
    </Box>
  );
};

export const EmptyCell = ({ content = '-' }: { content?: any }) => {
  return (
    <Box
      color="primary.400"
      width="100%"
      maxWidth={convertPxToRems(100)}
      fontSize="sm"
    >
      {content}
    </Box>
  );
};
